// src/components/AddChoreForm.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, query, onSnapshot } from 'firebase/firestore';

const AddChoreForm = ({ currentUser, onClose }) => { 
  const [task, setTask] = useState('');
  const [description, setDescription] = useState(''); // <-- NEW: Description state
  const [error, setError] = useState('');
  const [users, setUsers] = useState([]);
  const [assignedTo, setAssignedTo] = useState('');

  // ... (useEffect for fetching users is unchanged) ...
  useEffect(() => {
    const q = query(collection(db, 'users'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const usersData = [];
      querySnapshot.forEach((doc) => {
        usersData.push({ id: doc.id, ...doc.data() });
      });
      setUsers(usersData);
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!task.trim() || !assignedTo) {
        setError('Please fill out all fields.');
        return;
    }

    try {
      const assignedUser = users.find(u => u.id === assignedTo);

      await addDoc(collection(db, 'chores'), {
        task: task,
        isComplete: false,
        createdBy: currentUser.email,
        createdAt: serverTimestamp(),
        assignedTo: assignedTo, 
        assignedUserNickname: assignedUser.nickname || assignedUser.email,
        description: description, // <-- NEW: Save the description
      });

      // Reset form fields
      setTask('');
      setDescription(''); // <-- NEW: Reset description
      setAssignedTo('');
      setError('');
      onClose();
    } catch (err) {
      setError('Failed to add chore. Please try again.');
      console.error(err);
    }
  };

  return (
    <> 
      <form onSubmit={handleSubmit} className="add-chore-form">
        <input
          type="text"
          value={task}
          onChange={(e) => setTask(e.target.value)}
          placeholder="Chore Title (e.g., Take out trash)"
          required
        />
        <select value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)} required>
          <option value="" disabled>Assign to...</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.nickname || user.email}
            </option>
          ))}
        </select>
        
        {/* NEW: Optional Description Textarea */}
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Add an optional description... (e.g., 'Don't forget the recycling bin')"
          className="description-input"
        />

        <button type="submit">Add Chore</button>
      </form>
      {error && <p className="error-message">{error}</p>}
    </>
  );
};

export default AddChoreForm;